import React from 'react';
import { css } from '@emotion/react';
import Link from '../../primitives/link';
import Typography from '../../primitives/typography';
import { colors } from '../../primitives/colors';

const styles = {
    link: css({
        display: 'flex',
        alignItems: 'flex-end',
        lineHeight: '1',
    }),
    typography: css({
        color: colors.grey800,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        transition: 'color 0.2s',
        whiteSpace: 'nowrap',
        svg: {
            transition: 'transform 0.3s',
        },
        '[data-state="open"] &': {
            color: colors.primaryOrange,
            svg: {
                transform: 'rotate(180deg)',
            },
        },
    }),
};

const NavItem = ({
    to,
    className,
    children,
}: React.PropsWithChildren<{
    to?: string
    className?: string
}>): JSX.Element => {
    let element;

    if (to) {
        element = (
            <Link
                to={to}
                className={className}
                css={styles.link}
            >
                {children}
            </Link>
        );
    } else {
        element = (
            <div
                className={className}
                css={styles.link}
            >
                {children}
            </div>
        );
    }

    return (
        <Typography
            fontSize={{
                dt: 'xl',
            }}
            fontWeight="regular"
            css={styles.typography}
        >
            {element}
        </Typography>
    );
};

export default NavItem;
